// @flow

import { type IncomingPayment, getSafeCheckoutPaymentOptions } from '../incoming-payment';
import { type OutgoingPayment } from '../outgoing-payment';
import { type UserInputValues } from '../user-input-values';

export async function boletoOutgoingPaymentMapper(
  userInputValues: UserInputValues,
  incomingPayment: IncomingPayment,
): Promise<$Shape<OutgoingPayment>> {

  return {
    payment_type: 'boleto',
    payment_type_code: resolveBoletoPaymentTypeCodeFromIncomingPayment(incomingPayment),
  };
}

function resolveBoletoPaymentTypeCodeFromIncomingPayment(incomingPayment: IncomingPayment): string {
  if(incomingPayment.status !== 'OP') {
    return 'boleto';
  }

  const checkoutPaymentOptions = getSafeCheckoutPaymentOptions(incomingPayment);

  const boletopixEnabled = checkoutPaymentOptions.boleto && checkoutPaymentOptions.boleto.includes('boletopix');

  return boletopixEnabled ? 'boletopix' : 'boleto';
}
